import { SEARCH_OPERATORS } from '../constants/CrmSearchConstants';
import { getTimePeriodOption } from './dateUtils';
// Special marker used by CRM index UI for fiscal year offset
export const CUSTOMER_DATA_FILTERS_FISCAL_YEAR_ROLLING_OFFSET = '__hs__FISCAL_YEAR_OFFSET';

// For filtering with IN operator
export const createInFilter = (property, values) => ({
  operator: SEARCH_OPERATORS.IN,
  property,
  values
});

// For filtering with EQ operator
export const createEqualFilter = (property, value) => ({
  operator: SEARCH_OPERATORS.EQ,
  property,
  value
});

// For creating date range filters with explicit start/end dates
export const createBetweenFilter = (property, startDate, endDate) => ({
  operator: SEARCH_OPERATORS.BETWEEN,
  property,
  value: startDate,
  highValue: endDate,
  dateTimeFormat: 'DATE'
});

/**
 * For creating rolling date range filters, e.g. this month, next month, etc.
 * @param property - The property to filter on
 * @param timeUnit - The unit of time (MONTH, QUARTER, YEAR)
 * @param timeUnitCount - Number of time units
 * @param inclusive - Whether to include the current period
 * @param rollForward - Whether to look forward in time
 * @param fiscalYearOffset - Optional fiscal year offset
 */
export const createRollingDateRangeFilter = (property, timeUnit, timeUnitCount, inclusive = true, rollForward = false, fiscalYearOffset) => {
  return Object.assign({
    operator: SEARCH_OPERATORS.ROLLING_DATE_RANGE,
    property,
    timeUnit,
    timeUnitCount,
    inclusive,
    rollForward
  }, fiscalYearOffset !== undefined && fiscalYearOffset > 0 ? {
    rollingOffset: CUSTOMER_DATA_FILTERS_FISCAL_YEAR_ROLLING_OFFSET,
    rollingOffsetUnit: 'MONTH'
  } : {});
};

// Maps time period values to their corresponding filter parameters (for non-custom time periods)
export const getTimeUnitForTimePeriod = timePeriod => {
  return getTimePeriodOption(timePeriod);
};